import { DatePicker } from '@components/ui/date-picker';
import { UNKNOWN_DATE_VALUE } from '@utils/date';
import { format } from 'date-fns';
import React from 'react';

interface DobFieldProps {
  id: string;
  value: any;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
  /** CSS class for the date picker */
  className?: string;
  /** Render in compact mode (for inline editing in accordion) */
  compact?: boolean;
  /** Allow marking the DOB as "Unknown" (allow_unknown schema flag) */
  allowUnknown?: boolean;
}

/**
 * Standalone Date of Birth field component.
 * Renders a DatePicker for entering date of birth.
 * The age badge is displayed by the parent FormFieldRenderer component.
 */
export const DobField: React.FC<DobFieldProps> = ({
  id,
  value,
  onChange,
  error,
  disabled,
  placeholder,
  className,
  compact = false,
  allowUnknown = false,
}) => {
  const datePickerClassName = compact
    ? `h-8 ${error ? 'border-destructive focus-visible:ring-destructive' : ''} ${className || ''}`
    : `h-11 ${className || ''}`;

  return (
    <DatePicker
      id={id}
      value={value}
      onChange={(date, unknown) =>
        onChange(unknown ? UNKNOWN_DATE_VALUE : date ? format(date, 'yyyy-MM-dd') : '')
      }
      disabled={disabled}
      placeholder={placeholder || 'mm/dd/yyyy'}
      className={datePickerClassName}
      allowUnknown={allowUnknown}
    />
  );
};
